import type {Rec} from 'typings/portaro.be.types';
import type {RecordRow} from 'src/features/record-grid/lib/types';
import type {AjaxService} from 'core/data-services/ajax.service';
import type {DateTime} from 'luxon';
import {transferify} from 'shared/utils/data-service-utils';
import type {
    DayOptimisationOverviewResponse,
    OptimisationSumsResponse,
    OverallOptimisationOverviewResponse
} from 'src/features/sutor/pages/project-detail/reports-optimisation/types';

export class SutorReportsOptimisationDataService {
    public static serviceName = 'sutorReportsOptimisationDataService';

    public static readonly REPORT_FINANCIAL_SUMS_ROUTE = 'report-optimisation/financial-sums';
    public static readonly OVERALL_OVERVIEW_ROUTE = 'report-optimisation/overview/overall';
    public static readonly DAY_OVERVIEW_ROUTE = 'report-optimisation/overview/day';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getReportSums(project: Rec): Promise<OptimisationSumsResponse> {
        return this.ajaxService
            .createRequest(SutorReportsOptimisationDataService.REPORT_FINANCIAL_SUMS_ROUTE)
            .get(transferify({project}));
    }

    public async getOverallOverview(project: Rec): Promise<OverallOptimisationOverviewResponse> {
        return this.ajaxService
            .createRequest(SutorReportsOptimisationDataService.OVERALL_OVERVIEW_ROUTE)
            .get(transferify({project}));
    }

    public async getDayOverview(project: Rec, installationLogbook: RecordRow, date: DateTime): Promise<DayOptimisationOverviewResponse> {
        return this.ajaxService
            .createRequest(SutorReportsOptimisationDataService.DAY_OVERVIEW_ROUTE)
            .get(transferify({project, installationLogbook, date: date.toISODate()}));
    }
}